<template>
  <div class="chat-message" :class="{ owner: owner }">
    <p class="message-body">
      {{ message.isi_chat }}
    </p>
    <small class="d-block text-muted">
      {{ formatDateString(message.createdAt, true) }}
    </small>
  </div>
</template>

<script>
import { formatDateString } from '../../../../helper/helpernew'

export default {
  name: 'ChatMessage',
  props: {
    message: Object,
    owner: { type: Boolean, default: false },
  },
  methods: {
    formatDateString,
  },
}
</script>

<style src="./ChatMessage.scss" lang="scss" scoped></style>
